import { Button, ModalPopup, Stack } from 'components';
import { DraftNoteForm } from 'modules/notes/notePopup/noteEdit/presets';
import { NoteFormValues } from 'modules/notes/notePopup/noteEdit/utils';
import { StatusesItem } from 'store/clients/clientsSlice';
import { Drawer } from 'vaul';
import { useResponsive } from 'utils/hooks/useMediaQuery';

import style from './noteModal.module.scss';

type Props = {
  open: boolean;
  handleClose: () => void;
  note: Partial<NoteFormValues> | undefined;
  status: StatusesItem['id'];
  clientId: string;
  clientName: string;
  prependedClientId: string;
  onSubmitSuccess?: () => void;
  onDeleteSuccess?: () => void;
  onOpenAiScribeDrawer?: () => void;
};

const NoteContent = ({
  status,
  clientId,
  clientName,
  prependedClientId,
  note,
  onSubmitSuccess,
  onDeleteSuccess,
  onOpenAiScribeDrawer
}: Omit<Props, 'open' | 'handleClose'>) => {
  return (
    <DraftNoteForm
      status={status}
      clientId={clientId}
      clientName={clientName}
      prependedClientId={prependedClientId}
      note={{
        noteType: note?.noteType ?? ''
      }}
      onSubmitSuccess={onSubmitSuccess}
      onDeleteSuccess={onDeleteSuccess}
      onOpenAiScribeDrawer={onOpenAiScribeDrawer}
    />
  );
};

const NoteModal = ({
  open,
  handleClose,
  note,
  status,
  clientId,
  clientName,
  prependedClientId
}: Props) => {
  const { isTablet } = useResponsive();

  const body = (
    <Stack
      display="flex"
      flexDirection="column"
      gap="20px"
      height="100%"
      width="100%"
      flex={1}
      minHeight={0}
      overflow="hidden"
    >
      <p className={style.title}>Want to leave a note?</p>
      <Stack flex={1} minHeight={0} overflow="auto" px="1px" className={style.noteContent}>
        <NoteContent
          status={status}
          clientId={clientId}
          clientName={clientName}
          prependedClientId={prependedClientId}
          note={note}
          onSubmitSuccess={handleClose}
          onDeleteSuccess={handleClose}
          onOpenAiScribeDrawer={handleClose}
        />
      </Stack>
    </Stack>
  );

  if (isTablet) {
    return (
      <Drawer.Root
        open={open}
        onOpenChange={(nextOpen) => {
          if (!nextOpen) handleClose();
        }}
        modal={false}
        autoFocus={false}
        dismissible={false}
      >
        <Drawer.Portal>
          <div className={style.drawerOverlay} />
          <Drawer.Content className={style.drawerContent}>
            <Stack position="absolute" right="12px" top="12px">
              <Button
                icon={<span className="material-icons">close</span>}
                type="button"
                handleOnClick={handleClose}
                customStyleClass={style.closeButton}
              />
            </Stack>
            <div className={style.drawerBody}>{body}</div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    );
  }

  return (
    <ModalPopup
      open={open}
      handleClose={handleClose}
      customClassInsideContainer={style.modal}
      customClassModalContentContainer={style.contentContainer}
      customClassCloseIconContainer={style.closeIconContainer}
    >
      {body}
    </ModalPopup>
  );
};

export default NoteModal;
